
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24a12 12 0 1112-12 12 12 0 01-12 12zm0-23a11 11 0 1011 11A11 11 0 0012 1z"}}),_c('path',{attrs:{"d":"M12 19.5a7.5 7.5 0 117.5-7.5 7.5 7.5 0 01-7.5 7.5zm0-14a6.5 6.5 0 106.5 6.5A6.5 6.5 0 0012 5.5z"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"2"}}),_c('path',{attrs:{"d":"M12 14.5a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm0-4a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5z"}})])
          )
        }
      }
    